var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',[(_vm.group.showTitle !== false)?_c('pui-group-panel',{attrs:{"defaultClosed":!_vm.group.isOpenByDefault,"disabled":_vm.group.disabled,"title":_vm.piivoTranslate(_vm.group)}},[_vm._t("default")],2):_c('div',{staticClass:"pui-group-panel-hidden"},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }